/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.16",
    versionName: "0.2.0-nightly.2025.9.16",
    versionChannel: "nightly",
    buildDate: "2025-09-16T00:07:28.336Z",
    commitHash: "c2c4a94705a5d148f7096d2bfeebe4b643d57ce0",
};
